import { RECEIVE_CONTACTS } from '../actions/contacts'

export default function contacts (state = {}, action) {
	switch (action.type) {
		case RECEIVE_CONTACTS:
			return Object.values(action.contacts)
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/contacts.js